"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeStyle = exports.DurationStyle = exports.DateStyle = void 0;
var DateStyle = exports.DateStyle = /*#__PURE__*/function (DateStyle) {
  DateStyle["Long"] = "long";
  DateStyle["Full"] = "full";
  DateStyle["Medium"] = "medium";
  DateStyle["Short"] = "short";
  DateStyle["NoYear"] = "noyear";
  return DateStyle;
}({});
var TimeStyle = exports.TimeStyle = /*#__PURE__*/function (TimeStyle) {
  TimeStyle["FullOffset"] = "fullOffset";
  TimeStyle["Long"] = "long";
  TimeStyle["Full"] = "full";
  TimeStyle["Medium"] = "medium";
  TimeStyle["Short"] = "short";
  return TimeStyle;
}({});
var DurationStyle = exports.DurationStyle = /*#__PURE__*/function (DurationStyle) {
  DurationStyle["Long"] = "long";
  DurationStyle["Short"] = "short";
  DurationStyle["Narrow"] = "narrow";
  return DurationStyle;
}({});
//# sourceMappingURL=model.js.map